import { useState, useEffect, useRef } from 'react';

export const ActiveTab = {
  summary: 'summary',
  doctor: 'doctor',
  wellbeingScores: 'wellbeingScores',
  priorityActions: 'priorityActions',
};

const SECTION_POSITION_OFFSET = 200;

const handleLinks = (data) => {
  const { description, longevityCheckResults, reports, infoBannerNoFrench } = data;
  const { wellbeingScores, priorityActions } = longevityCheckResults;
  const useEnglishText = !!infoBannerNoFrench;

  let links = [];

  if (description && !reports?.doctorReport) {
    links.push(
      useEnglishText
        ? { text: 'Summary', sectionsId: ActiveTab.summary }
        : { textId: 'app.summary', sectionsId: ActiveTab.summary }
    );
  }
  if (reports?.doctorReport) {
    links.push(
      useEnglishText
        ? { text: "Doctor's Report", sectionsId: ActiveTab.doctor }
        : { textId: 'app.doctors-report', sectionsId: ActiveTab.doctor }
    );
  }
  if (wellbeingScores) {
    links.push(
      useEnglishText
        ? { text: 'Wellbeing Scores', sectionsId: ActiveTab.wellbeingScores }
        : { textId: 'test-result.wellbeing-scores', sectionsId: ActiveTab.wellbeingScores }
    );
  }
  if (priorityActions) {
    links.push(
      useEnglishText
        ? { text: 'Priority Actions', sectionsId: ActiveTab.priorityActions }
        : { textId: 'test-result.priority-actions', sectionsId: ActiveTab.priorityActions }
    );
  }

  return links;
};

const useScrollHandlerForLongevityCheck = ({ data }) => {
  const linksData = handleLinks(data);
  const [activeSection, setActiveSection] = useState(linksData[0].sectionsId);

  const scrollableElementRef = useRef(null);

  const handleScroll = (scrollTop) => {
    const summaryScrollPosition = document.getElementById('summary')?.offsetTop;
    const doctorsReportPosition = document.getElementById('doctor')?.offsetTop;
    const wellbeingScoresPosition =
      document.getElementById('wellbeingScores')?.offsetTop;
    const priorityActionsPosition =
      document.getElementById('priorityActions')?.offsetTop;

    const positions = [
      { id: ActiveTab.summary, position: summaryScrollPosition },
      { id: ActiveTab.doctor, position: doctorsReportPosition },
      { id: ActiveTab.wellbeingScores, position: wellbeingScoresPosition },
      { id: ActiveTab.priorityActions, position: priorityActionsPosition },
    ].filter((pos) => pos.position !== undefined);

    positions.sort((a, b) => a.position - b.position);

    for (let i = 0; i < positions.length; i++) {
      const { id, position } = positions[i];
      //TODO: for now this, later we change it so we dont use Infinity
      const nextPosition = positions[i + 1]?.position ?? Infinity;

      if (
        scrollTop >= position - SECTION_POSITION_OFFSET &&
        scrollTop < nextPosition - SECTION_POSITION_OFFSET
      ) {
        if (activeSection !== id) {
          setActiveSection(id);
        }
        break;
      }
    }
  };

  useEffect(() => {
    const scrollableElement = scrollableElementRef.current;

    const handleScrollEvent = () => {
      handleScroll(scrollableElement?.scrollTop, activeSection);
    };

    if (scrollableElement) {
      scrollableElement.addEventListener('scroll', handleScrollEvent);
    }

    return () => {
      if (scrollableElement) {
        scrollableElement.removeEventListener('scroll', handleScrollEvent);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSection]);

  return {
    scrollableElementRef,
    activeSection,
    linksData,
  };
};

export default useScrollHandlerForLongevityCheck;
